/**
 * Centralized Zod schemas for topic generation — single source of truth for the FE.
 *
 * These mirror the BE schemas in `supabase/functions/_shared/topic-content.ts`
 * and are consumed by `useStreamObject` hooks across the app.
 */
import { z } from "zod";

// --- Questions -------------------------------------------------------------

export const questionsResponseSchema = z.object({
  questions: z.array(
    z.object({
      question: z.string(),
      difficulty: z.enum(["beginner", "intermediate", "advanced"]),
      stepByStep: z.array(z.string()),
      exampleAnswer: z.string(),
      keyPoints: z.array(z.string()),
    }),
  ),
});

// --- Vocabulary -------------------------------------------------------------

export const vocabularyResponseSchema = z.object({
  vocabulary: z.array(
    z.object({
      word: z.string(),
      definition: z.string(),
      example: z.string(),
      ipa: z.string().optional(),
      type: z.string().optional(),
      certLevel: z.enum(["A1", "A2", "B1", "B2", "C1", "C2"]),
    }),
  ),
});

// --- Speaking Guide --------------------------------------------------------

const expressionSchema = z.object({
  phrase: z.string(),
  meaning: z.string(),
  example: z.string(),
});

const grammarSpotlightSchema = z.object({
  title: z.string(),
  rule: z.string(),
  example: z.string(),
});

export const speakingGuideResponseSchema = z.object({
  naturalExpressions: z.array(expressionSchema),
  sentenceStarters: z.array(z.string()),
  conversationFillers: z.array(z.string()),
  grammarSpotlight: grammarSpotlightSchema.optional(),
});